import { useMemo } from "react";
import constate from "constate";
import { /**
   * Hook to access the feature flags from the VizFrameworkProvider.
   * This is the only place where feature flags should be accessed.
   */ // eslint-disable-next-line
useFeatureFlags } from "@chronosphereio/core";
function useConfigInternal(args) {
    const featureFlags = useFeatureFlags();
    return useMemo(()=>{
        return {
            featureFlags,
            ...args
        };
    }, [
        args,
        featureFlags
    ]);
}
export const [VizFrameworkConfigProvider, useConfigStrict] = constate(useConfigInternal);
/**
 * Hook to access the config object from the VizFrameworkProvider.
 */ export function useVizFrameworkConfig() {
    try {
        return useConfigStrict();
    } catch (e) {
        return undefined;
    }
}

//# sourceMappingURL=config.js.map